<alert *ngIf="preguntasNotPlatform && preguntasNotPlatform.length > 0" type="danger">
    <strong>Error: Preguntas exclusivas</strong>
    <p>Las siguientes preguntas son exclusivas de otras plataformas:</p>
    <ul *ngFor="let pregunta of preguntasNotPlatform">
        <li>Pregunta ID #{{ pregunta.id }}</li>
    </ul>
    <p>Habilite las preguntas para poder utilizarlas en esta plataforma.</p>
</alert>
